import * as DiscussionActions from '../actions/discussionActions';

const defaultState = {
    discussion: []
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case DiscussionActions.ACTION_GET_VIDEO_DISCUSSION:
            return {
                ...state,
                discussion: action.payload
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/discussionReducer.js